<template>
  <div class="back-button">
    <i class="el-icon-back" />
    <span>Voltar</span>
  </div>
</template>

<script>
export default {
  name: 'Func4BackButton'
}
</script>

<style scoped lang="less">

.back-button {
  color: var(--cor-primaria-aplicacao);
  cursor: pointer;
  display: flex;
  font-weight: bold;
  gap: 8px;
  padding-right: 8px;
  place-items: center;

  i {
    font-size: 16px;
  }
}

</style>
